export default __webpack_public_path__ + "static/media/sticker-1.cdbac030.png";